import { Sandbox } from "@/components/Sandbox";
import { usePermissions } from "@/hooks/usePermissions";
import { useNavigate } from "react-router-dom";

export const SandboxPage = () => {
  const navigate = useNavigate();
  const { isAdminOrSupport } = usePermissions();

  if (!isAdminOrSupport) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold mb-4">Acesso Negado</h1>
          <p className="text-muted-foreground mb-4">
            Apenas usuários Administrador e Suporte podem acessar o Sandbox.
          </p>
          <button
            onClick={() => navigate("/")}
            className="px-4 py-2 bg-primary text-primary-foreground rounded-md"
          >
            Voltar ao Dashboard
          </button>
        </div>
      </div>
    );
  }

  const handleBack = () => navigate("/");
  return <Sandbox onBack={handleBack} />;
};
